// Store testimonials shown on home and PDP. The last four entries once carried
// a "temporary presentation copy" note; the owner decided on 2026-09-16 that
// all eight are permanent production content, so the note was removed rather
// than the entries. Treat this list as owner-owned copy.
//
// Order (2026-09-21): store-experience stories lead, the entries that talk
// about prescription work sit at the end. On a sunglasses PDP a lead card
// about progressive lenses reads as a claim about THAT frame. No review text
// was changed, only the sequence.
//
// Provenance of the three profile URLs: the owner gave them in the session of
// 2026-09-21, asking for the seller profiles to be linked here. Nothing else
// in the workspace records them — `src/core/config/business.ts` `sameAs` still
// lists only Instagram, TikTok, Facebook and Pinterest — so whoever adds a
// marketplace here needs the owner, not a search. Moving all four/seven links
// into `sameAs` and reading them from there is an open proposal.
//
// The marketplace credentials below were read from the public seller profiles
// on 2026-09-21. Left column = what we publish, right column = what the
// profile showed that day. Re-check when the section is next touched; the
// "sudayframes" spelling is eBay's own store slug, not a typo.
//   eBay      SundayFrames      "99%+ positive"  <- 99.9% positive feedback,
//                               rounded down by us
//                               "2.8K sold"      <- eBay's own rounded
//                               display of items sold, reproduced as shown
//   Poshmark  @sunday_sun_day   "Ambassador II"  <- POSH AMBASSADOR II
//                               "100+ love notes" <- profile shows
//                               "Received (100+)", reproduced as shown
//   Grailed   DesignerEyewear   "Trusted Seller" <- Trusted Seller badge
//                               "140+ reviews"   <- 5.0 from 146 reviews,
//                               rounded down by us
export const customerTrustContent = {
  eyebrow: "Store reviews",
  title: "TRUSTED BY OVER 10K CUSTOMERS",
  // Says what the block IS, without asserting a property of all eight texts:
  // several of them do mention the frame they bought ("the color is even
  // nicer in person"), so "every review is about the store" would be
  // falsifiable by reading three cards down.
  subtitle:
    "Reviews of the store and our service, from buyers on the marketplaces where we sell.",
  // The non-breaking spaces keep each number with its unit on one line;
  // on a 390px phone the three columns are ~106px wide and break otherwise.
  marketplaces: [
    {
      id: "ebay",
      name: "eBay",
      href: "https://www.ebay.com/str/sudayframes",
      metric: "99%+ positive · 2.8K sold",
    },
    {
      id: "poshmark",
      name: "Poshmark",
      href: "https://poshmark.com/closet/sunday_sun_day",
      metric: "Ambassador II · 100+ love notes",
    },
    {
      id: "grailed",
      name: "Grailed",
      href: "https://www.grailed.com/DesignerEyewear",
      metric: "Trusted Seller · 140+ reviews",
    },
  ],
  reviews: [
    {
      id: "elena-rossi",
      name: "Elena Rossi",
      rating: 5,
      verified: true,
      content:
        "Shipping was fast, packaging was beautiful, and the sunglasses feel premium. I have already recommended this store to two friends because everything from checkout to delivery felt smooth and reliable.",
    },
    {
      id: "marcus-reed",
      name: "Marcus Reed",
      rating: 5,
      verified: true,
      content:
        "Found the exact pair I had been looking for and the price was much better than what I saw locally. Shipping updates were clear and they arrived sooner than I expected.",
    },
    {
      id: "daniel-kim",
      name: "Daniel Kim",
      rating: 5,
      verified: true,
      content:
        "Really impressed with the value. The pair looked exactly like the photos, customer support answered my questions quickly, and the whole experience felt much better than buying from a marketplace seller.",
    },
    {
      id: "olivia-brooks",
      name: "Olivia Brooks",
      rating: 5,
      verified: true,
      content:
        "This was my second order and it was just as easy as the first. The sunglasses arrived in perfect shape and the color is even nicer in person.",
    },
    {
      id: "sophie-carter",
      name: "Sophie Carter",
      rating: 5,
      verified: true,
      content:
        "I was a little nervous ordering frames online, but they looked just like the pictures and fit me really well. They also came packed carefully, which I appreciated.",
    },
    {
      id: "nina-patel",
      name: "Nina Patel",
      rating: 5,
      verified: true,
      content:
        "The size details were actually helpful, so I knew what I was getting before I ordered. I had them adjusted a tiny bit at my optician and now I wear them every day.",
    },
    {
      id: "maria-santos",
      name: "Maria Santos",
      rating: 5,
      verified: true,
      content:
        "I bought these glasses about a month ago I think. They’re my first ever pair of glasses and I was iffy about if I would like them or not, but I LOVE them! They’re gorgeous and fit perfect.",
    },
    {
      id: "james-miller",
      name: "James Miller",
      rating: 5,
      verified: true,
      content:
        "I purchased these glasses maybe 3 weeks ago. Manufacture took short of 2 weeks with progressive lenses and all the extras. The frame quality is excellent and they fit perfectly right out of the box.",
    },
  ],
};
